// BdePipeline.tsx
import { Card, Row, Col, Typography, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import BdePipelineCard from './BdePipelineCard';
import { useDispatch } from 'react-redux';
import { getData } from '../../../../../../actions/apiCall';


const { Title } = Typography;
const { Option } = Select;

const pipelineData = [
    { stage: 'New Leads', count: 12, bg: '#722ED1', color: 'white' }, // Purple
    { stage: 'Contacted', count: 12, bg: '#FA8C16', color: 'white' }, // Orange
    { stage: 'Qualified', count: 0, bg: '#F5F5F5', color: '#BFBFBF' }, // Light Gray/No Leads
    { stage: 'In Discussion', count: 12, bg: '#1890FF', color: 'white' }, // Blue
    { stage: 'Proposal Shared', count: 12, bg: '#52C41A', color: 'white' }, // Green
    { stage: 'Closed', count: 12, bg: '#1890FF', color: 'white' }, // Blue
    { stage: 'Dropped', count: 12, bg: '#F5222D', color: 'white' }, // Red
];

interface DepartmentOption {
    label: string;
    value: string;
}

const BdePipeline: React.FC = () => {
    const dispatch = useDispatch();
    const [departments, setDepartments] = useState<DepartmentOption[]>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<string>("all");

    useEffect(() => {
        fetchDepartments();
    }, []);

    const fetchDepartments = async () => {
        const res: any = await dispatch(getData("/departments"));

        console.log("Departments API Response:", res);

        // ✅ CORRECT based on your API
        const departmentList = res?.data;

        if (Array.isArray(departmentList)) {
            const options: DepartmentOption[] = [
                { label: "All Departments", value: "all" },
                ...departmentList.map((dept: any) => ({
                    label: dept.name,
                    value: dept._id,
                })),
            ];

            setDepartments(options);
        } else {
            console.error("Departments is not an array", departmentList);
        }
    };

    return (
        <Card
            className='bde_margin'
            title={<Title level={4} style={{ margin: 0 }}>BDE Pipeline</Title>}
            extra={
                <Select
                    className="w-48"
                    value={selectedDepartment}
                    options={departments}
                    onChange={(value) => setSelectedDepartment(value)}
                    placeholder="Select Department"
                />
            }
            style={{ marginBottom: 24 }}
        >

            <Row gutter={[16, 16]} style={{ display: 'flex' }}>
                {pipelineData.map((data, index) => (
                    <Col
                        key={index}

                        style={{
                            flex: 1,
                            maxWidth: 'calc((100% / 7) - 16px)',
                            minWidth: 100
                        }}
                    >
                        <BdePipelineCard
                            stage={data.stage}
                            count={data.count}
                            backgroundColor={data.bg}
                            color={data.color}
                        />
                    </Col>
                ))}
            </Row>
        </Card>
    )
};

export default BdePipeline;